import type { SettingsTranslations } from '../interfaces/settings';

export const settingsTranslations: SettingsTranslations = {
  title_page: 'Configurações',
  subtitle_page: 'Preferências do workspace e da sua conta',
  nav_preferences: 'Preferências',
  nav_integrations: 'Integrações',
  nav_organization: 'Organização',
  nav_roles: 'Funções e políticas',
  nav_billing: 'Plano e faturamento',
  settings_eyebrow: 'Configurações',
  settings_group_account: 'Conta',
  settings_group_integrations: 'Integrações',
  settings_group_organization: 'Organização',
  language_label: 'Idioma',
  general_settings_title: 'Geral',
  domain_settings_title: 'Dominio',
  integrations_settings_title: 'Integrações',
  theme_label: 'Tema',
  theme_description: 'Alterna entre aparência clara e escura.',
  theme_light: 'Claro',
  theme_dark: 'Escuro',
  language_description: 'Escolha o idioma usado em todo o dashboard.',

  appearance_section_title: 'Aparência',
  appearance_theme_card_title: 'Tema',
  appearance_theme_card_sub: 'Escolha como a interface se vê. O modo Sistema segue a preferência do sistema operacional.',
  appearance_theme_light_hint: 'Indicado para ambientes bem iluminados.',
  appearance_theme_dark_hint: 'Menos brilho, ideal para ambientes escuros.',
  appearance_theme_system_label: 'Sistema',
  appearance_theme_system_hint: 'Segue o modo claro ou escuro do seu sistema.',

  language_eyebrow: 'Idioma',
  language_section_title: 'Idioma da interface',
  language_section_description: 'Aplica-se instantaneamente em todos os textos do aplicativo.',
  language_interface_label: 'Idioma',
  language_interface_hint: 'Sua escolha é salva neste navegador.',

  // Billing
  billing_title: 'Plano e faturamento',
  billing_subtitle: 'Gerencie sua assinatura, métodos de pagamento e faturas.',
  billing_current_plan_label: 'Plano atual',
  billing_renews_on: 'Renova em {{date}}',
  billing_per_month: '/ mês',
  billing_per_year: '/ ano',
  billing_view_invoice: 'Ver fatura',
  billing_upgrade_plan: 'Atualizar plano',
  billing_no_subscription_title: 'Você não tem uma assinatura ativa',
  billing_no_subscription_subtitle:
    'Escolha um plano para começar a usar o {{brand}} e desbloquear todos os canais e agentes.',
  billing_choose_plan: 'Escolher plano',
  billing_loading: 'Carregando...',
  billing_usage_of: 'de {{max}}',
  billing_usage_unlimited: 'Ilimitado',
  billing_usage_disabled: 'Não incluído',
  billing_usage_per_month: '/ mês',
  billing_feature_agents_active: 'Agentes ativos',
  billing_feature_whatsapp_numbers: 'Números WhatsApp',
  billing_feature_team_members: 'Membros da equipe',
  billing_feature_ai_messages_monthly: 'Mensagens IA',
  billing_feature_whatsapp_conversations_monthly: 'Conversas',
  billing_payment_method_title: 'Método de pagamento',
  billing_payment_method_coming_soon_title: 'Em breve',
  billing_payment_method_coming_soon_description:
    'Estamos trabalhando na integração com gateways de pagamento. Por enquanto, o faturamento é processado manualmente pelo nosso time.',
  billing_payment_method_change: 'Alterar',
  billing_invoices_title: 'Histórico de faturas',
  billing_invoices_empty_title: 'Ainda não há faturas',
  billing_invoices_empty_description:
    'Os pagamentos vinculados à sua assinatura aparecerão aqui assim que forem gerados.',
  billing_invoices_status_succeeded: 'Paga',
  billing_invoices_status_pending: 'Pendente',
  billing_invoices_status_failed: 'Falhou',
  billing_invoices_status_refunded: 'Reembolsada',
  billing_invoices_status_cancelled: 'Cancelada',
  billing_tax_data_title: 'Dados de faturamento',
  billing_tax_data_coming_soon_title: 'Em breve',
  billing_tax_data_coming_soon_description:
    'Em breve você poderá salvar seus dados fiscais para que apareçam em suas faturas.',
  billing_tax_data_legal_name: 'Razão social',
  billing_tax_data_tax_id: 'CNPJ / Tax ID',
  billing_tax_data_address: 'Endereço',
  billing_change_plan_dialog_title: 'Mudar de plano',
  billing_change_plan_dialog_description:
    'Escolha seu novo plano. A mudança é aplicada imediatamente e reinicia o período de faturamento.',
  billing_change_plan_dialog_confirm: 'Confirmar mudança',
  billing_change_plan_dialog_cancel: 'Cancelar',
  billing_change_plan_billing_monthly: 'Mensal',
  billing_change_plan_billing_annual: 'Anual',
  billing_change_plan_current_badge: 'Plano atual',
  billing_change_plan_recommended_badge: 'Recomendado',
  billing_change_plan_popular_badge: 'Mais popular',
  billing_change_plan_no_plans:
    'Não há planos disponíveis no momento. Entre em contato para ajudarmos a escolher um.',
  billing_change_plan_success_toast: 'Plano atualizado com sucesso.',
  billing_change_plan_error_toast: 'Não foi possível atualizar o plano.',
  billing_change_plan_cta_current: 'Plano atual',
  billing_change_plan_cta_choose: 'Mudar para {{name}}',
  billing_change_plan_cta_contact: 'Falar com vendas',
  billing_change_plan_features_title: 'Inclui',
  billing_change_plan_billed_monthly_caption: 'cobrado mensalmente',
  billing_change_plan_billed_annual_caption: '{{total}} cobrados anualmente',
  billing_change_plan_custom_price: 'Sob medida',
  billing_change_plan_custom_price_caption: 'conforme volume',
  billing_change_plan_unlimited_suffix: 'ilimitadas',
  billing_change_plan_per_month_suffix: '/ mês',
  billing_change_plan_back: 'Voltar ao resumo',
  billing_change_plan_cta_continue: 'Continuar com {{name}}',
  billing_change_plan_need_more: 'Precisa de mais?',
  billing_change_plan_need_more_hint: 'Para alto volume, SSO ou compliance,',
  billing_change_plan_annual_savings: '−2 meses',
  billing_change_plan_free_caption: 'sem cobrança',
  billing_trial_cta_start: 'Iniciar teste gratuito de {{days}} dias',
  billing_trial_cta_disabled_tooltip:
    'Em breve · entre em contato com vendas para ativar',
  billing_trial_days_free_badge: '{{days}} dias grátis',

  billing_trial_title: 'Você está em teste gratuito',
  billing_trial_badge: 'Sem plano',
  billing_trial_subtitle:
    'Restam {{daysLeft}} de {{daysTotal}} dias. Escolha um plano para que seus agentes continuem respondendo depois.',
  billing_trial_progress_label: '{{daysLeft}} dias restantes',
  billing_no_plan_title: 'Você ainda não tem um plano ativo',
  billing_no_plan_badge: 'Sem plano',
  billing_no_plan_subtitle:
    'Ative um plano para que seus agentes continuem respondendo e desbloquear todos os canais.',

  billing_trial_usage_title: 'Seu uso durante o teste',
  billing_trial_usage_subtitle: 'Ajuda você a estimar qual plano precisa.',
  billing_trial_usage_conversations: 'Conversas',
  billing_trial_usage_conversations_projection:
    '≈ {{projected}} / mês projetado',
  billing_trial_usage_agents: 'Agentes criados',
  billing_trial_usage_agents_caption: 'incluindo rascunhos',
  billing_trial_usage_accounts: 'Contas conectadas',
  billing_trial_usage_accounts_caption: 'pelos seus canais',

  billing_faq_title: 'Antes de escolher',
  billing_faq_subtitle: 'As dúvidas mais comuns.',
  billing_faq_q1: 'O que acontece quando meu teste termina?',
  billing_faq_a1:
    'Seus agentes pausam respostas e avisamos por email 3 dias antes. Seus dados e configurações ficam guardados por 90 dias caso reative.',
  billing_faq_q2: 'Posso mudar de plano depois?',
  billing_faq_a2:
    'Sim. Subir é imediato e proporcional. Descer aplica no fechamento do ciclo. Sem multa.',
  billing_faq_q3: 'Tem desconto se eu pagar anual?',
  billing_faq_a3: 'Sim, equivale a 2 meses grátis sobre a tarifa mensal.',

  billing_checkout_back: 'Mudar de plano',
  billing_checkout_confirm_title: 'Confirme seu pedido',
  billing_checkout_confirm_subtitle:
    'Leva menos de um minuto. Cobramos quando seu teste terminar.',
  billing_checkout_plan_label: 'Plano selecionado',
  billing_checkout_plan_chip_interval_monthly: 'Mensal',
  billing_checkout_plan_chip_interval_annual: 'Anual',
  billing_checkout_card_title: 'Método de pagamento',
  billing_checkout_card_subtitle: 'Criptografia SSL. Não armazenamos seu CVC.',
  billing_checkout_card_number: 'Número do cartão',
  billing_checkout_card_expiry: 'Vencimento',
  billing_checkout_card_cvc: 'CVC',
  billing_checkout_card_holder: 'Nome do titular',
  billing_checkout_tax_title: 'Dados de faturamento',
  billing_checkout_tax_legal_name: 'Razão social',
  billing_checkout_tax_id: 'CNPJ / Tax ID',
  billing_checkout_tax_address: 'Endereço fiscal',
  billing_checkout_summary_label: 'Resumo',
  billing_checkout_summary_billing: 'Faturamento',
  billing_checkout_summary_subtotal: 'Plano {{name}}',
  billing_checkout_summary_tax: 'Imposto (16%)',
  billing_checkout_summary_total_today: 'Total hoje',
  billing_checkout_pay_button: 'Pagar e ativar',
  billing_checkout_pay_processing: 'Processando…',
  billing_checkout_pay_disclaimer: 'Não cobramos até o fim do seu teste.',
  billing_checkout_guarantee_title: 'Cancele quando quiser',
  billing_checkout_guarantee_description:
    'Garantia de 30 dias. Pagamento criptografado. Dados em SOC2 + GDPR.',

  billing_done_label: 'Plano ativado',
  billing_done_welcome: 'Bem-vindo ao {{name}}!',
  billing_done_renews_caption:
    '{{price}} · faturamento {{interval}} · renova em {{date}}',
  billing_done_view_invoice: 'Ver fatura',
  billing_done_next_steps_title: 'Próximos passos',
  billing_done_next_steps_subtitle:
    'Aproveite ao máximo seu plano em menos de 5 minutos.',
  billing_done_step_connect_title: 'Conecte mais contas',
  billing_done_step_connect_desc:
    'Adicione mais WhatsApp, Instagram ou seu site para multiplicar o alcance.',
  billing_done_step_handoff_title: 'Ative o handoff humano',
  billing_done_step_handoff_desc:
    'Para conversas que precisam de toque humano ou pedidos complexos.',
  billing_done_step_webhook_title: 'Configure webhooks',
  billing_done_step_webhook_desc:
    'Receba eventos no seu backend: leads qualificados, vendas fechadas, erros.',
  billing_done_go_to_overview: 'Ir ao resumo',
  meta_capi_title: 'Meta Pixel · Conversions API',
  meta_capi_subtitle:
    'Atribua conversas de WhatsApp aos seus anúncios Click-to-WhatsApp e meça conversões reais no Meta Ads.',
  meta_capi_pixel_id_label: 'Pixel ID',
  meta_capi_access_token_label: 'Access token',
  meta_capi_access_token_set: 'Token salvo',
  meta_capi_access_token_change: 'Alterar',
  meta_capi_test_event_code_label: 'Código de evento de teste (opcional)',
  meta_capi_test_event_code_hint:
    'Quando definido, os eventos aparecem na aba "Test Events" do Events Manager.',
  meta_capi_enabled_label: 'Habilitado',
  meta_capi_save: 'Salvar configuração',
  meta_capi_test_event: 'Enviar evento de teste',
  meta_capi_test_event_sent:
    'Evento de teste enfileirado. Veja o log abaixo em alguns segundos.',
  meta_capi_how_to_get_token: 'Como obter?',
  meta_capi_how_to_get_token_body:
    'Meta Business Suite → Configurações → Conjuntos de dados → Pixel → Gerar token de acesso. Você precisa de permissões de admin no pixel.',
  meta_capi_events_title: 'Últimos eventos enviados',
  meta_capi_events_empty: 'Nenhum evento enviado ainda.',
  meta_capi_status_queued: 'Na fila',
  meta_capi_status_sent: 'Enviado',
  meta_capi_status_failed: 'Tentando novamente',
  meta_capi_status_dead: 'Falhou',
  meta_capi_toast_saved: 'Configuração salva.',
  meta_capi_toast_error: 'Não foi possível salvar. Tente de novo.',
  meta_capi_required_field: 'Este campo é obrigatório',
  // API keys
  nav_api_keys: 'Chaves de API',
  nav_api_usage: 'Uso da API',
  settings_group_developers: 'Desenvolvedores',
  api_keys_eyebrow: 'Desenvolvedores',
  api_keys_section_title: 'Chaves de API',
  api_keys_section_description:
    'Crie chaves de API para acesso programático e atribua a elas uma ou mais funções que definam suas permissões.',
  api_keys_new: 'Nova chave de API',
  api_keys_col_name: 'Nome',
  api_keys_col_key: 'Chave',
  api_keys_col_roles: 'Funções',
  api_keys_col_status: 'Status',
  api_keys_col_created: 'Criada',
  api_keys_col_last_used: 'Último uso',
  api_keys_status_active: 'Ativa',
  api_keys_status_disabled: 'Revogada',
  api_keys_never_used: 'Nunca',
  api_keys_empty_title: 'Você ainda não tem chaves de API',
  api_keys_empty_description:
    'Crie sua primeira chave para acessar a API com as permissões de uma função.',
  api_keys_load_error: 'Não foi possível carregar as chaves de API',
  api_keys_action_edit_roles: 'Editar funções',
  api_keys_action_rotate: 'Rotacionar segredo',
  api_keys_action_revoke: 'Revogar',
  api_keys_action_enable: 'Reativar',
  api_keys_action_delete: 'Excluir',
  api_keys_cancel: 'Cancelar',
  api_keys_create_title: 'Nova chave de API',
  api_keys_create_description:
    'Nomeie a chave e escolha as funções que definirão suas permissões.',
  api_keys_create_submit: 'Criar chave de API',
  api_keys_name_label: 'Nome',
  api_keys_name_placeholder: 'Ex.: Integração CI',
  api_keys_name_required: 'O nome é obrigatório',
  api_keys_roles_label: 'Funções',
  api_keys_roles_description:
    'A chave herda as permissões das funções selecionadas.',
  api_keys_roles_placeholder: 'Selecione uma ou mais funções',
  api_keys_roles_required: 'Selecione ao menos uma função',
  api_keys_edit_roles_title: 'Editar funções',
  api_keys_edit_roles_description:
    'Atualize as funções associadas a esta chave de API.',
  api_keys_edit_roles_submit: 'Salvar',
  api_keys_col_cidrs: 'Faixas de IP',
  api_keys_cidrs_none: 'Sem restrição',
  api_keys_cidrs_count: '{{n}} faixa(s)',
  api_keys_action_edit_cidrs: 'Editar faixas de IP',
  api_keys_cidrs_label: 'Faixas de IP permitidas (CIDR)',
  api_keys_cidrs_description:
    'Opcional. Se você adicionar faixas, a chave só funciona a partir de IPs dentro delas. Vazio = sem restrição. Digite um CIDR e pressione Enter.',
  api_keys_cidrs_placeholder: 'Ex. 190.85.0.0/16',
  api_keys_cidrs_invalid: 'Insira faixas CIDR válidas (ex. 10.0.0.0/8).',
  api_keys_edit_cidrs_title: 'Editar faixas de IP',
  api_keys_edit_cidrs_description:
    'Restrinja esta chave de API a uma lista de faixas CIDR (IPv4/IPv6). Deixe vazio para permitir qualquer IP.',
  api_keys_edit_cidrs_submit: 'Salvar',
  api_keys_secret_title: 'Guarde seu segredo',
  api_keys_secret_description:
    'Copie estes valores agora. O segredo é exibido apenas uma vez e você não poderá vê-lo novamente.',
  api_keys_secret_public_label: 'Chave de API (x-api-key)',
  api_keys_secret_secret_label: 'Segredo (x-secret)',
  api_keys_secret_warning:
    'O segredo não é armazenado em texto puro. Se você o perder, precisará rotacioná-lo.',
  api_keys_secret_copy: 'Copiar',
  api_keys_secret_copied: 'Copiado',
  api_keys_secret_close: 'Concluído',
  api_keys_rotate_title: 'Rotacionar o segredo?',
  api_keys_rotate_description:
    'Um novo segredo será gerado e o atual deixará de funcionar imediatamente. As integrações que o utilizam falharão na autenticação.',
  api_keys_revoke_title: 'Revogar esta chave de API?',
  api_keys_revoke_description:
    'A chave deixará de autenticar imediatamente. Você pode reativá-la mais tarde.',
  api_keys_enable_title: 'Reativar esta chave de API?',
  api_keys_enable_description: 'A chave voltará a autenticar solicitações.',
  api_keys_delete_title: 'Excluir esta chave de API?',
  api_keys_delete_description:
    'Esta ação é permanente e não pode ser desfeita.',
  api_keys_toast_created: 'Chave de API criada.',
  api_keys_toast_roles_updated: 'Funções atualizadas.',
  api_keys_toast_cidrs_updated: 'Faixas de IP atualizadas.',
  api_keys_toast_rotated: 'Segredo rotacionado.',
  api_keys_toast_revoked: 'Chave de API revogada.',
  api_keys_toast_enabled: 'Chave de API reativada.',
  api_keys_toast_deleted: 'Chave de API excluída.',
  api_keys_toast_error: 'Algo deu errado. Tente novamente.',
  meta_ads_title: 'Meta Ads',
  meta_ads_subtitle: 'Conecte suas contas de anúncios da Meta para ver campanhas e métricas de mídia no {{brand}}.',
  meta_ads_no_connection_title: 'Sem conexão com a Meta',
  meta_ads_no_connection_body: 'Autorize o {{brand}} com sua conta da Meta para ler suas contas de anúncios. Somente leitura: não criamos nem alteramos campanhas.',
  meta_ads_connect_button: 'Conectar com a Meta',
  meta_ads_badge_connected: 'Conectada',
  meta_ads_badge_reauth: 'Requer reconexão',
  meta_ads_reauth_title: 'A autorização expirou',
  meta_ads_reauth_body: 'Reconecte sua conta da Meta para que o {{brand}} continue lendo seus dados de anúncios.',
  meta_ads_expires_label: 'Autorização válida até',
  meta_ads_never_expires: 'A autorização não expira',
  meta_ads_disconnect: 'Desconectar',
  meta_ads_accounts_title: 'Contas de anúncios',
  meta_ads_accounts_empty: 'Nenhuma conta de anúncios vinculada ainda. Carregue as disponíveis e escolha quais ler.',
  meta_ads_load_available: 'Carregar contas disponíveis',
  meta_ads_available_title: 'Disponíveis na sua conta da Meta',
  meta_ads_available_empty: 'Sua conta da Meta não tem contas de anúncios visíveis.',
  meta_ads_account_connect: 'Vincular',
  meta_ads_account_connected: 'Vinculada',
  meta_ads_not_covered: 'Sem permissão do token',
  meta_ads_account_status_active: 'Ativa',
  meta_ads_account_status_other: 'Verificar na Meta',
  meta_ads_toast_connected: 'Conta da Meta conectada.',
  meta_ads_toast_account_connected: 'Conta de anúncios vinculada.',
  meta_ads_toast_disconnected: 'Desconectado.',
  meta_ads_toast_cancelled: 'Conexão cancelada.',
  meta_ads_toast_error: 'Algo deu errado. Tente novamente.',
  meta_ads_sdk_error: 'Não foi possível carregar o SDK do Facebook. Verifique sua conexão ou bloqueador de anúncios.',
  meta_ads_config_missing: 'O id de configuração de login do Meta Ads não está definido para este ambiente.',
};
